export default "__VITE_ASSET__BR$W_yOr__"